
export const mitreDocTypes = [
    'x-mitre-tactic',
    'x-mitre-asset',
    'attack-pattern',
    'course-of-action',
    'intrusion-set',
    'malware',
    'tool',
    'x-mitre-data-source',
    'x-mitre-data-component',
    'identity',
    'campaign',
    'relationship',
];

// TODO: These document type labels are hardcoded for now. 
// Check if dynamic labels are available in the database and remove this hardcoded mapping.
export const docTypes = {
    'x-mitre-asset': 'Asset',
    'campaign': 'Campaign',
    'x-mitre-tactic': 'Tactic',
    'attack-pattern': 'Technique',
    'course-of-action': 'Mitigation',
    'intrusion-set': 'Group',
    'malware': 'Software (Malware)',
    'tool': 'Software (Tool)',
    'x-mitre-data-source': 'Data Source',
    'x-mitre-data-component': 'Data Component',
    'relationship': 'Relationship',
    'identity': 'Identity',
  };

export const UI_LABELS = {
    tools: 'tools',
    stack: 'technologies',
};

export const DATE_FILTER_CONDITIONS = [
    { value: 'range', label: 'From – To' },
    { value: 'gte', label: 'On or After' },
    { value: 'lte', label: 'On or Before' },
    { value: 'withIn', label: 'With In' },
];

export const DATE_WITH_IN = [
    { value: 'DAYS', label: 'Days' },
    { value: 'MONTHS', label: 'Months' },
    { value: 'YEARS', label: 'Years' },
];

export const recommendationParametersFields = [
    {
        fieldName: 'minScore',
        label: 'Minimum Score',
        type: 'NUMBER',
        minValue: 0.05,
        maxValue: 1,
        steps: 0.01

    },
    {
        fieldName: 'maxDocs',
        label: 'Max Number of Docs',
        type: 'NUMBER',
        minValue: 1,
        maxValue: 50,
        steps: 1

    },
]; 